import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";
import store from '@store'

export default [
  // ===
  // 關於
  // ===
  {
    path: '/product/brand/microsoft/solutionhub/about',
    name: 'about-list',
    component: () => lazyLoadView(import('@views/About/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      title: '關於我們'
    },
  },
]